import React from 'react';

import { useLogo } from 'components/hooks/useLogo';

import { makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
  },
  bigImage: {
    width: '40px',
    height: '40px',
  },
  smallImage: {
    display: 'block',
    width: '40px',
    height: '40px',
  },
}));

const ScreenLogo = ({ onClick, impersonated }) => {
  const classes = useStyles();
  const { smallLogoUrl, smallLogoImpersonatedUrl } = useLogo();

  return (
    <div onClick={onClick} className={classes.root}>
      <svg className={classes.smallImage}>
        <use
          href={
            (impersonated ? smallLogoImpersonatedUrl : smallLogoUrl) + '#logo'
          }
        ></use>
      </svg>
    </div>
  );
};

export default ScreenLogo;
